import React from "react";
import {
  Paper,
  Box,
  Typography,
  TextField,
  InputAdornment,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  TablePagination,
  IconButton,
  Tooltip,
  Chip,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

const JudgeNameTable = ({
  judgeNames,
  page,
  rowsPerPage,
  setPage,
  setRowsPerPage,
  search,
  setSearch,
  onEdit,
  onDelete,
}) => {

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Paper
      elevation={3}
      sx={{
        mt: 2,
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 2,
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Typography variant="h6" fontWeight="bold">
          Judge Name List
        </Typography>

        <TextField
          size="small"
          placeholder="Search Judge..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{
            width: {
              xs: "100%",
              sm: 300,
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <TableContainer>

        <Table>

          <TableHead>

            <TableRow sx={{ backgroundColor: "#1976d2" }}>

              <TableCell sx={{ color: "#fff", fontWeight: 700 }}>
                S.No.
              </TableCell>

              <TableCell sx={{ color: "#fff", fontWeight: 700 }}>
                Judge Name
              </TableCell>

              <TableCell sx={{ color: "#fff", fontWeight: 700 }}>
                Status
              </TableCell>

              <TableCell
                align="center"
                sx={{ color: "#fff", fontWeight: 700 }}
              >
                Action
              </TableCell>

            </TableRow>

          </TableHead>

          <TableBody>            {judgeNames && judgeNames.length > 0 ? (
              judgeNames
                .slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
                .map((item, index) => (
                  <TableRow hover key={item.id}>

                    <TableCell>
                      {page * rowsPerPage + index + 1}
                    </TableCell>

                    <TableCell>
                      {item.judge_name}
                    </TableCell>

                    <TableCell>
                      {item.status ? (
                        <Chip
                          label="Active"
                          color="success"
                          icon={<CheckCircleIcon />}
                          size="small"
                        />
                      ) : (
                        <Chip
                          label="Inactive"
                          color="error"
                          icon={<CancelIcon />}
                          size="small"
                        />
                      )}
                    </TableCell>

                    <TableCell align="center">

                      <Tooltip title="Edit">
                        <IconButton
                          color="primary"
                          onClick={() => onEdit(item)}
                        >
                          <EditIcon />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Delete">
                        <IconButton
                          color="error"
                          onClick={() => onDelete(item.id)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>

                    </TableCell>

                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  No Judge Name Found
                </TableCell>
              </TableRow>
            )}

          </TableBody>

        </Table>

      </TableContainer>

      <TablePagination
        component="div"
        count={judgeNames.length}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleRowsPerPageChange}
        rowsPerPageOptions={[5, 10, 20, 50]}
      />

    </Paper>
  );
};

export default JudgeNameTable;